"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireWildcard(require("./Icon"));
const _excluded = ["fill"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IconOpenSource = _ref => {
  let {
      fill
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    label: "Open source"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 0C3.58933 0 0 3.70689 0 8.26242C0 11.6612 2.06267 14.7566 5.132 15.9642C5.396 16.0727 5.70133 15.9197 5.78733 15.6358L7.28733 10.6887C7.35867 10.4543 7.26067 10.2004 7.05267 10.0821C6.40333 9.71206 6 9.01506 6 8.26242C6 7.12301 6.89667 6.19647 8 6.19647C9.10267 6.19647 10 7.12301 10 8.26242C10 9.01506 9.59733 9.71276 8.948 10.0835C8.74 10.2011 8.64133 10.455 8.71333 10.6901L10.2133 15.6372C10.2993 15.9231 10.6027 16.072 10.8687 15.9656C13.938 14.7566 16 11.6612 16 8.26242C16 3.70689 12.4113 0 8 0Z",
    fill: fill
  }));
};
IconOpenSource.defaultProps = {
  fill: 'black'
};
IconOpenSource.propTypes = Object.assign({}, _Icon.propTypes, {
  fill: _propTypes.default.string
});
var _default = exports.default = IconOpenSource;